import React from "react"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { MessageCircle, Instagram } from "lucide-react"

export default function Book() {
  const bookImages = [
    "/images/WTF.jpeg",
    "/images/Dum.jpeg",
    "/images/Dicti.jpeg",
    "/images/Poet.jpeg",
    "/images/Text.jpeg",
    "/images/book1.jpeg",
    "/images/book2.jpeg",
    "/images/book3.jpeg",
  ]

  const handleWhatsAppMessage = () => {
    const message = encodeURIComponent(
      "Hello, I'm interested in your book 'W.T.F is healing?'. Could you give me more information?"
    )
    window.open(`https://wa.me/+351965220370?text=${message}`, "_blank")
  }

  const handleInstagramMessage = () => {
    const profileUrl =
      "https://www.instagram.com/luis_breatho/?igsh=MWJnZ2gwemhmZTQ4bQ=="
    window.open(profileUrl, "_blank")
  }

  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <h1 className="text-5xl mb-12 text-center text-purple-800 font-['Muar-Stencil']">
          W.T.F is healing? (the short book)
        </h1>

        <div className="flex flex-col md:flex-row gap-12 mb-12">
          <div className="md:w-2/5 relative group">
            <img
              src="/images/LB.jpeg"
              alt="Cover of the book W.T.F is healing"
              className="w-full rounded-lg shadow-2xl transition duration-300 group-hover:shadow-purple-300"
            />
            <div className="absolute inset-0 bg-purple-800 bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg"></div>
          </div>
          <div className="md:w-3/5 flex flex-col">
            <div className="flex-grow">
              <p className="text-lg leading-relaxed text-gray-300 mb-4 font-['Muar-Regular']">
                After 7 years working in the “healing industry”, I found some
                things to say about what healing is. <b>And is not</b>. A
                poetical and philosophical approach to one of the things of the
                fashion – that is a reach for eternity, health and ease. But
                first of all, the question: are we really making the right
                questions? Includes 5 levels of healing, and illustrations by
                the author. None of the above was made with A.I. You can buy a
                physical copy <b>here</b>. Shipping worldwide, for the price of
                10 euros (1 copy) or 20 euros (3 copies).
              </p>
            </div>
            <div className="mt-4">
              <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
                <button
                  onClick={handleWhatsAppMessage}
                  className="flex-1 bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center"
                >
                  <MessageCircle className="mr-2" size={20} />
                  WhatsApp
                </button>
                <button
                  onClick={handleInstagramMessage}
                  className="flex-1 bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center"
                >
                  <Instagram className="mr-2" size={20} />
                  Instagram
                </button>
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-3xl mt-12 mb-6 text-center text-purple-800 font-['Muar-Stencil']">
          Image Gallery
        </h2>
        <div className="max-w-2xl mx-auto">
          <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            infiniteLoop={true}
            className="rounded-lg overflow-hidden shadow-2xl"
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  className="absolute left-0 z-10 p-3 bg-black bg-opacity-50 hover:bg-opacity-75 transition-opacity duration-300 rounded-r-lg top-1/2 transform -translate-y-1/2"
                >
                  <span className="sr-only">Previous</span>
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </button>
              )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  className="absolute right-0 z-10 p-3 bg-black bg-opacity-50 hover:bg-opacity-75 transition-opacity duration-300 rounded-l-lg top-1/2 transform -translate-y-1/2"
                >
                  <span className="sr-only">Next</span>
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              )
            }
          >
            {bookImages.map((image, index) => (
              <div
                key={index}
                className="aspect-w-3 aspect-h-4 sm:aspect-w-16 sm:aspect-h-9"
              >
                <img
                  src={image}
                  alt={`Page ${index + 1} of the book`}
                  className="object-contain w-full h-full"
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  )
}
